import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  AccessManagementOrgUnitCollectionOURecord,
  AccessManagementOrgUnitCollectionRecord,
} from '@cdw-ae/common-data';
import { CdwButtonModule } from '@cdw-ae/common-ui-components-button';
import { CdwCheckboxModule } from '@cdw-ae/common-ui-components-checkbox';
import { CdwDividerModule } from '@cdw-ae/common-ui-components-divider';
import { CdwFilteredTreePickerModule } from '@cdw-ae/common-ui-components-filtered-tree-picker';
import { CommonUiComponentsTextInputModule } from '@cdw-ae/common-ui-components-text-input';
import { TreeNode } from '@cdw-ae/common-ui-components-tree';

@Component({
  selector: 'lib-cdw-ou-collection-edit',
  templateUrl: './cdw-ou-collection-edit.component.html',
  styleUrls: ['./cdw-ou-collection-edit.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CdwButtonModule,
    CdwCheckboxModule,
    CdwDividerModule,
    CdwFilteredTreePickerModule,
    CommonUiComponentsTextInputModule,
  ],
})
export class CdwOuCollectionEditComponent implements OnInit {
  readonly grey400Color = getComputedStyle(document.documentElement)
    .getPropertyValue('--color-primary-gray-400')
    .trim();

  @Input() ouCollection!: AccessManagementOrgUnitCollectionRecord | undefined;

  @Input() ouCollectionOus!: AccessManagementOrgUnitCollectionOURecord[];

  @Input() ouSelectOptions: TreeNode[] = [];

  @Output() cancelOuCollectionEdit = new EventEmitter();

  @Output() submitOuCollectionEdit = new EventEmitter();

  @Output() deleteOuCollection = new EventEmitter();

  OuCollectionForm!: FormGroup;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    if (this.ouCollection) {
      this.OuCollectionForm = this.formBuilder.group({
        name: [this.ouCollection.name, Validators.required],
        description: [this.ouCollection.description, Validators.required],
        ous: [this.ouCollectionOus.map((ou) => ou.orgUnit?.value).filter(Boolean)],
      });
    } else {
      this.OuCollectionForm = this.formBuilder.group({
        name: ['', Validators.required],
        description: ['', Validators.required],
        ous: [[], Validators.required],
      });
    }
  }

  public onDeleteOuCollection() {
    this.deleteOuCollection.emit();
  }

  public onSaveOuCollection() {
    if (!this.OuCollectionForm?.controls) {
      return;
    }

    const selectedOus = this.OuCollectionForm.get('ous')?.value as string[];

    const OuCollectionData: {
      name: string;
      description: string;
      ous: string[];
    } = {
      name: this.OuCollectionForm.get('name')?.value as string,
      description: this.OuCollectionForm.get('description')?.value as string,
      ous: selectedOus || [],
    };
    this.submitOuCollectionEdit.emit(OuCollectionData);
  }

  public onCancelOuCollection() {
    this.cancelOuCollectionEdit.emit();
  }
}
